import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

import { INFORMATION_ROUTES } from '#modules/informations/routes/informations.routes';
import { menuV2FeatureGuard } from '#modules/menu-v2/guards/menu-v2-feature.guard';
import { MENU_ROUTES } from '#modules/menu/routes/menu.routes';
import { SEO_POSTS_ROUTES } from '#modules/posts/routes/seo-posts.routing';

export const SEO_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/seo-layout/seo/seo-layout.component').then((m) => m.SeoLayoutComponent),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'informations',
            },
            {
                path: 'informations',
                loadChildren: () => INFORMATION_ROUTES,
                data: { routePath: RoutePath.INFORMATIONS },
            },
            {
                path: 'posts',
                loadChildren: () => SEO_POSTS_ROUTES,
                data: { routePath: RoutePath.POSTS },
            },
            {
                path: 'menu',
                canMatch: [menuV2FeatureGuard],
                loadChildren: () => import('#modules/menu-v2/routes/menu-v2.routes').then((m) => m.MENU_V2_ROUTES),
                data: { routePath: RoutePath.MENU },
            },
            {
                path: 'menu',
                loadChildren: () => MENU_ROUTES,
                data: { routePath: RoutePath.MENU },
            },
        ],
    },
];
